export const SITE_DOMAIN = 'bariyerlibondexsunger.com';
export const SITE_ORIGIN = `https://${SITE_DOMAIN}`;

export function toAbsoluteUrl(pathname: string): string {
  const clean = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${SITE_ORIGIN}${clean}`;
}

export function canonicalizePathname(pathname: string): string {
  const url = new URL(pathname, SITE_ORIGIN);
  url.hash = '';
  url.search = '';
  // no trailing slash except root
  if (url.pathname !== '/' && url.pathname.endsWith('/')) {
    url.pathname = url.pathname.slice(0, -1);
  }
  return url.pathname;
}
